import { create } from "zustand";

type TasksRefreshState = {
  version: number;
  bump: () => void;
};

// Every useMyTasks() instance (header peek, tasks page, dashboard card, ...)
// keeps its own local task list. Bumping this after a mutation makes every
// mounted instance refetch, instead of each one going stale until reload.
export const useTasksRefreshStore = create<TasksRefreshState>()((set) => ({
  version: 0,
  bump: () => set((state) => ({ version: state.version + 1 })),
}));
